import { Location } from '@angular/common';
import { ExpedientesService } from './../../services/expedientes.service';
import { Component, OnInit, ElementRef, Renderer2, ViewChild } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-adjunto',
  templateUrl: './adjunto.component.html',
  styleUrls: ['./adjunto.component.css']
})
export class AdjuntoComponent implements OnInit {
  adjunto={};
  archivo="";
  codigo;
  @ViewChild("mensajeAdjunto") mensaje: ElementRef;
  @ViewChild("subirArchivo") archivoSubido: ElementRef;
  constructor(private location: Location, private router:Router, private activatedRoute:ActivatedRoute,
     private expedientesService:ExpedientesService, private renderer:Renderer2) {
      
    if(!this.expedientesService.expedienteActivo){
      this.location.back();
    }
    
    this.activatedRoute.params.subscribe(params=>{
      this.codigo=params["cod"];

    });
   }

  ngOnInit() {
    if(this.codigo=="nuevo"){
      this.adjunto={};
    }else{
      this.cargarAdjunto();
    }
  }

  cargarAdjunto(){
    this.expedientesService.getAdjunto(this.codigo)
    .subscribe(resp=>{
      this.adjunto=resp["adjunto"];
    });
  }

  guardarAdjunto(){
    if(this.codigo=="nuevo"){
      this.insertAdjunto();
    }else{
      this.updateAdjunto();
    } 
    
  }

  updateAdjunto(){
    this.expedientesService.updateAdjunto(this.adjunto, this.codigo)
    .subscribe(resp=>{
      
      let texto=this.renderer.createText(resp["mensaje"]);
        if(resp["err"]==false){
          this.renderer.addClass(this.mensaje.nativeElement, "text-success");
        }else{
          this.renderer.addClass(this.mensaje.nativeElement, "text-danger");
        }

        this.renderer.appendChild(this.mensaje.nativeElement,texto);
        setTimeout(() => {
          this.renderer.removeChild(this.mensaje.nativeElement,texto);
        }, 2000);
      return true;
    });
  }

  insertAdjunto(){
    this.adjunto["EDcodexpediente"]=this.expedientesService.expedienteActivo["EXcodigo"];
    
    this.expedientesService.insertAdjunto(this.adjunto, this.archivoSubido.nativeElement.files[0])
    .subscribe(resp=>{
      if(resp["err"]==false){
        this.location.back();
      }
    });
  }

  /* descargarAdjunto(nombrefichero){
    
  } */

  volver(){
    this.location.back();
  }
}




// WEBPACK FOOTER //
// ./src/app/components/adjunto/adjunto.component.ts